import { Box, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';

function Footer() {

    const [newDate, setNewDate] = useState('');

    useEffect(() => {
        let todayDate = new Date();
        let todayYear = todayDate.getFullYear();
        setNewDate([todayYear]);
    }, []);

  return (
    <Box component="footer" sx={{ paddingBottom: '1rem' }}>
        <Typography sx={{ textAlign: 'center', padding: '1rem', fontWeight: 600 }}>
            PR Builders — construction & home builders in East Tambaram, Chennai
        </Typography>
        <Typography sx={{ textAlign: 'center', paddingX: '1rem', color: 'text.secondary', fontSize: '0.9rem' }}>
            Serving Tambaram, South Chennai, and Tamil Nadu · Vengadamangalam, Chennai 600127
        </Typography>
        <Typography sx={{ textAlign: 'center', padding: '1rem' }}>
            copyright {newDate} &copy; PR Builders
        </Typography>
    </Box>
  )
}

export default Footer;